import { render, staticRenderFns } from "./VincularPessoa.vue?vue&type=template&id=3e1ccd08&scoped=true&lang=pug"
import script from "./VincularPessoa.vue?vue&type=script&lang=js"
export * from "./VincularPessoa.vue?vue&type=script&lang=js"
import style0 from "./VincularPessoa.vue?vue&type=style&index=0&id=3e1ccd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ccd08",
  null
  
)

export default component.exports